import React from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";

import ChangePassword from "./ChangePassword.jsx";
import CreateNewPassword from "./CreateNewPassword.jsx";
import ForgotPassword from "./ForgotPassword.jsx";
import Login from "./Login.jsx";

const LoginSwitch = (props) => {
	return (
		<div>
			<Transition in timeout={1} appear>
				{(status) => {
					return (
						<div className={`login-switch ${status}`}>
							{props.forgotPassword ? (
								<ForgotPassword
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputEmail={props.loginInputEmail}
									loginInputPassword={props.loginInputPassword}
								/>
							) : props.createNewPassword ? (
								<CreateNewPassword
									codeDeliveryMessage={props.codeDeliveryMessage}
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputVerificationCode={props.loginInputVerificationCode}
									loginInputNewPassword={props.loginInputNewPassword}
								/>
							) : props.forceChangePassword ? (
								<ChangePassword
									codeDeliveryMessage={props.codeDeliveryMessage}
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputVerificationCode={props.loginInputVerificationCode}
									loginInputChangePasswordNew={props.loginInputChangePasswordNew}
									loginInputChangePasswordOld={props.loginInputChangePasswordOld}
									userJustLoggedIn={props.userJustLoggedIn}
								/>
							) : (
								<Login
									dispatch={props.dispatch}
									validationInProgress={props.validationInProgress}
									loginError={props.loginError}
									loginErrorText={props.loginErrorText}
									loginInputEmail={props.loginInputEmail}
									loginInputPassword={props.loginInputPassword}
								/>
							)}
						</div>
					);
				}}
			</Transition>
		</div>
	);
};

LoginSwitch.propTypes = {
	codeDeliveryMessage: PropTypes.string.isRequired,
	createNewPassword: PropTypes.bool.isRequired,
	dispatch: PropTypes.func.isRequired,
	forceChangePassword: PropTypes.bool.isRequired,
	forgotPassword: PropTypes.bool.isRequired,
	loginInputChangePasswordNew: PropTypes.string.isRequired,
	loginInputChangePasswordOld: PropTypes.string.isRequired,
	loginError: PropTypes.bool.isRequired,
	loginErrorText: PropTypes.string.isRequired,
	loginInputEmail: PropTypes.string.isRequired,
	loginInputPassword: PropTypes.string.isRequired,
	loginInputVerificationCode: PropTypes.string.isRequired,
	loginInputNewPassword: PropTypes.string.isRequired,
	userJustLoggedIn: PropTypes.bool.isRequired,
	validationInProgress: PropTypes.bool.isRequired,
};

export default LoginSwitch;
